export default {
  actionTypes: {
    loadSuppliers: 'LOAD_SUPPLIERS',
    updatePaginationInfo: 'UPDATE_PAGINATION_INFO',
    onFilterQueryChanged: 'ON_FILTER_QUERY_CHANGED',
    addNewSupplier: 'ADD_NEW_SUPPLIER',
    updateSupplier: 'UPDATE_SUPPLIER',
    resendEmailVerification: 'RESEND_EMAIL_CONFIRMATION',
  },
  mutationTypes: {
    setSuppliers: 'SET_SUPPLIERS',
    setSuppliersTotal: 'SET_SUPPLIERS_TOTAL',
    setIsLoading: 'SET_IS_LOADING',
    setPaginationInfo: 'SET_PAGINATION_INFO',
    setFilterQuery: 'SET_FILTER_QUERY',
    setPaginationInfoPageNumber: 'SET_PAGINATION_PAGE_NUMBER',
  },
};
